export default __webpack_public_path__ + "static/media/closeIcon.992af563.svg";